import { render, staticRenderFns } from "./salesTargetAgentDetail.vue?vue&type=template&id=129f0022&scoped=true&"
import script from "./salesTargetAgentDetail.vue?vue&type=script&lang=js&"
export * from "./salesTargetAgentDetail.vue?vue&type=script&lang=js&"
import style0 from "./salesTargetAgentDetail.vue?vue&type=style&index=0&id=129f0022&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f0022",
  null
  
)

export default component.exports